<template>
    <div class="task-operate">
        <order-handle-dialog
        :isDialog="isDialog"
        :dialogVisible="dialogVisible"
        :handle-close="closeDialog"
        :operate="data.statusResult"
        :task="task"
        title="操作"
        @before-submit="beforeSubmit"
        @on-success="onSuccess"
        @on-error="onError"
        :orderDetail="orderDetail"
        ></order-handle-dialog>
        <!-- 驳回原因 -->
        <p class="reason" v-if="showReason">{{reasonLabel}} : {{this.task.reason}}</p>
        <!-- 待审核状态下才有的编辑 -->
        <el-button type="warning" v-if="showEdit" @click.stop="handleClick('BIAN_JI')">编辑</el-button>
				
        <el-button v-for="(item,index) in acceptableResult" :key="index" type="warning"  @click.stop="handleClick(item)">{{formatActionAcceptableResult(item)}}</el-button>
    </div>
</template>
<script>
import { formatActionAcceptableResult } from 'enumeration/trust-deed.js'
import { nextActionResults } from 'json/trust-deed.js'
import orderHandleDialog from 'cps/trust-deed/pt-order-handle/dialog'
export default {
  props: {
    // 接收一个task类型对象
    task: {
      type: Object,
    },
    // 点击按钮的确认逻辑
    confirm: {
      type: Function
    },
    orderDetail: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  components: {
    orderHandleDialog
  },
  data () {
    return {
      dialogVisible: false,
      isDialog: true,
      data: {
        taskId: this.task?.id,
        ...this.params
      }
    }
  },
  computed: {
    showReason(){
      const status = ['BILL_CHECKED','BILL_RECEIVE']
      return status.includes(this.task?.billActionData.action)
    },
    reasonLabel(){
      let res ='驳回原因'
      switch (this.task?.billActionData.action) {
        case 'BILL_RECEIVE':
          res = '异常原因'
          break
      }
      return res
    },
    showEdit(){
      return this.task?.billActionData.action === "BILL_CHECKED"
    },
    acceptableResult () {
      let res = this.task?.billActionData?.futureActionAcceptableResults || []
      console.log('===res',res,this.task)
      let sortIndexKey = nextActionResults.map(e => e.key)
      return this.sortByKey(JSON.parse(JSON.stringify(res)), JSON.parse(JSON.stringify(sortIndexKey)))
    }
  },
  watch: {
    params: {
      handler () {
        this.data = { ...this.data, ...this.params }
      },
      deep: true
    },
    task: {
      handler (val) {
        console.log('====w',val)
        this.data.taskId = this.task?.id
      },
      deep: true
    }
  },
  methods: {
    formatActionAcceptableResult,
    sortByKey (arr, referArr) {
      arr.sort((prev, next) => {
        return referArr.indexOf(prev) - referArr.indexOf(next)
      })
      return arr
    },
    // showBtn (task) {
    //   // 待处理时显示
    //   return task.status === 'ACTION_REQUIRED'
    // },
    beforeSubmit () {
      this.$emit('before-submit')
    },
    onSuccess (data) {
      this.$emit('on-success', data,this.data.statusResult)
    },
    onError (err) {
      this.$emit('on-error', err)
    },
    closeDialog () {
      this.dialogVisible = false
    },
    showDialog () {
      this.dialogVisible = true
    },
    handleClick (type) {
      console.log('===bianji')
      // 编辑
      if (type === 'BIAN_JI') {
        this.$router.push(`/trust-deed-form/true/${this.$route.params.id}`)
        return
      }
      // 独立表单的
      if (type === 'YAN_QI_JIAO_FU') {
        this.isDialog = false
      }
      if (type === 'RE_PROVIDE') {
        this.$router.push(`/batch-add-lab-order?billId=${this.orderDetail.id}&billCode=${this.orderDetail.billCode}&recollect=true`)
        return
      }
      this.data.statusResult = type
      this.showDialog()
    }
  }
}
</script>
<style lang="less">
.task-operate {
  .reason{
    font-size: 16px;
    margin-bottom: 20px;
  }
}
</style>
